import React, { Component } from 'react'
import { Row, Breadcrumb } from 'antd'
import { app, api } from "./app"
import './css/bottomMenu.css'
import Head from "./components/Head"
import Footer from "./components/Footer"
import 'braft-editor/dist/output.css'

class BottomMenu extends Component {
    constructor (props) {
        super(props)
        this.state = {
            d_loading: false,
            dataInfo: {submenu: []},
            name: ''
        }
    }

    componentDidMount () {
        this._isMounted = true
        let name = this.props.match.params.name
        name && this.handleData(name)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    componentWillReceiveProps(nextProps) {
        console.log(nextProps)
        if (nextProps.match.params.name && this.state.name !== nextProps.match.params.name) {
            this.handleData(nextProps.match.params.name)
        }
    }

    /**
     * 数据
     * @returns {Promise<void>}
     */
    handleData = async (name) => {
        await this.setData({ d_loading: true, name })
        let { flag, data, msg } = await app.post(api.BottomMenuDetail, {name})
        if (flag !== 1) {
            data = {}
            app.alert(msg, "error")
        }
        await this.setData({ dl_loading: false, dataInfo: data })
    }

    handleTo = (name) => {
        if (name === '视频展播') {
            this.props.history.replace('/videos')
        } else {
            this.props.history.replace('/other/' + name)
        }
    }

    setData = (data) => app.setStateSync(this, data)

    render () {
        let {name, dataInfo, dl_loading} = this.state
        return (
            <div className="bottom-menu">
                <div className="bm-head">
                    <Head history={this.props.history} center height="auto"/>
                </div>
                <div className="bm-content">
                    <div className="bmc-b">
                        <Breadcrumb separator=">">
                            <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                            <Breadcrumb.Item>{dataInfo.parent_name}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="bmc-c">
                        <Row type="flex" justify="space-between" align="bottom">
                            <div className="bmcc-ltab">{dataInfo.parent_name}</div>
                            <div>
                                {
                                    dataInfo.submenu.map((sub, i) => {
                                        if (sub === name) {
                                            return (
                                                <div key={i} className='bmcc-tab-sel'>{sub}</div>
                                            )
                                        } else {
                                            return (
                                                <div key={i} className="bmcc-tab" onClick={() => this.handleTo(sub)}>{sub}</div>
                                            )
                                        }
                                    })
                                }
                            </div>
                        </Row>
                        <div className="bncc-c" dangerouslySetInnerHTML={{ __html: dataInfo.content }}></div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default BottomMenu



// WEBPACK FOOTER //
// ./src/BottomMenu.jsx